import React, { useState, useEffect } from 'react'
import { Panel, Input, ControlLabel, Message, Row } from 'rsuite'
import { useForm } from 'react-hook-form'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { startLoading, doneLoading } from '../../utils/loading'
import { updateChangeAgreement, updateSendEditContract } from '../../redux/actions/contract'
import { useHistory } from 'react-router-dom'
import {
  saveAttachmentModifyContract,
  deleteAttachmentGrantee,
  getDownloadAttachmentGrantee,
  getSendEditContract,
} from '../../redux/actions/contract'
import AttachFilesMakeContract from '../../widgets/makeContract/AttachFilesMakeContract'
import AttachFilesView from '../../widgets/makeContract/AttachFilesMakeContractView'
import EditButton from '../../components/buttons/editButton/EditButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import pathname from '../../constants/pathname'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import AIEvaluationResultWidget from '../aiEvaluation/AIEvaluationResultWidget'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, PROCESS_SUCCESS_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { checkAiEvaluationStatus, sendAiEvaluation } from '../../redux/actions/aiEvaluation'
import { isEmpty } from 'lodash-es'
import AIEvaluationProcessWidget from '../aiEvaluation/AIEvaluationProcessWidget'

export default function AgreementAdditional(props) {
  const { showCommandButton, isEditAll, isEditContract, isAIEvaliation } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [schema, setFormSchema] = useState(props.schema)
  const [schemaAttachments, setSchemaAttachments] = useState(props.schemaAttachments)
  const [hideHead, setHideHead] = useState(props.hideHead)
  const [hideSubmit, setHideSubmit] = useState(props.hideSubmit)
  const [section1, setSection1] = useState(props.section1)
  const [isLoading, setIsLoading] = useState()
  const [isError, setIsError] = useState()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [memo, setMemo] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)
  const [isPrepareFile, setIsPrepareFile] = useState(false)

  const [evaluationResultSchema, setEvaluationResultSchema] = useState(props.evaluationResult)
  const [isIntervalGetEvaluation, setIsIntervalGetEvaluation] = useState()
  const [isContinue, setIsContinue] = useState(false)

  const [evalOpen, setEvalOpen] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    if (isIntervalGetEvaluation) {
      IntervalCheckEvaluation()
    }
  }, [isIntervalGetEvaluation])

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    let request = {
      projectVersionId: projectId,
      userId: '',
      value: memo,
    }

    // console.log('request', JSON.stringify(request))

    try {
      var response
      isEditContract
        ? (response = await updateSendEditContract(request, projectId))
        : (response = await updateChangeAgreement(request, projectId))
      // console.log('response', response)
      if (response) {
        // scrollToComponent(section1, { offset: 0, align: 'top', duration: 500 })
        // setHideHead(true)
        // setHideSubmit(false)
        // let callBackData = {
        //   hideHead_CallBack: hideHead,
        //   hideSubmit_CallBack: !hideSubmit,
        //   section1_CallBack: section1,
        //   response_CallBack: response,
        // }
        // props.onCallBack(callBackData)
        setIsLoading(false)
        doneLoading()
        setShowConfirm(false)
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      }
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data?.errors?.Message) {
        setIsError(e?.response?.data?.errors?.Message)
      } else {
        setIsError(schema.buttonText + `ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`)
      }
    }
    setIsLoading(false)
    doneLoading()
    setShowConfirm(false)
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      console.log('upload')
      const response = await saveAttachmentModifyContract(request, projectId)
      console.log('response', response)

      if (response) {
        const _response = await getSendEditContract(projectId)
        setSchemaAttachments(_response.model.forms.attachments)
        setIsUploadErr(false)

        setIsPrepareFile(false)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (id) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      console.log('call delete.')
      const status = await deleteAttachmentGrantee(projectId, id)
      if (status) {
        const _response = await getSendEditContract(projectId)
        setSchemaAttachments(_response.model.forms.attachments)
        setIsDeleteError(false)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const IntervalCheckEvaluation = async () => {
    while (true) {
      try {
        if (isEmpty(evaluationResultSchema.statusMessage)) {
          break
        }
        // console.log('IntervalCheckEvaluation loop')
        const response = await checkAiEvaluationStatus(evaluationResultSchema.id)
        // const response = await getAiEvaluationResult(projectId)
        if (response) {
          setEvaluationResultSchema(response)

          if (isEmpty(response.statusMessage)) {
            setIsIntervalGetEvaluation(false)
            // console.log('เสร็จแล้ว หยุด loop')
            break
          }
        }
      } catch (err) {
        // console.error('error:', err)
      }

      // รอ 20 วินาที
      await new Promise((resolve) => setTimeout(resolve, 20000))
    }
  }

  const handleProposalEvaluation = async () => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await sendAiEvaluation(projectId)

      if (response) {
        setEvaluationResultSchema(response)
        if (!isEmpty(response.statusMessage)) {
          setIsIntervalGetEvaluation(true)
        }
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await getDownloadAttachmentGrantee(projectId, fileObj.id)
    // var file = []

    const url = window.URL.createObjectURL(new Blob([file]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await getDownloadAttachmentGrantee(projectId, fileObj.id)
    // var file = []

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onUpload = (data) => {
    console.log('onSubmit data', data)
    const file = data[schemaAttachments.attachFiles.name]
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    formData.append('MasterContractFileId', data.contractFileType || '')
    formData.append('ProjectVersionId', projectId || '')
    formData.append('UserId', '')

    handleUpload(formData)
  }

  const onUpdate = (file, newName) => {
    console.log('onUpdate file', file, 'newName: ', newName)

    file['projectVersionId'] = projectId
    file['userId'] = 111
    file.label = newName

    console.log('file', file)
    //handleUpdate(file)
  }

  const onDelete = (id) => {
    handleDelete(id)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    setMemo(data.note)
    setShowConfirm(true)

    // handleCallService(request)
  }

  const handleCheckEvaluation = async (id) => {
    startLoading()
    setIsLoading(true)

    try {
      const response = await checkAiEvaluationStatus(id)
      // const response = await getAiEvaluationResult(projectId)
      // const responde = { step: mockEvaluation, result: mockSchema }
      if (response) {
        setEvaluationResultSchema(response)

        notification.open('success', {
          title: PROCESS_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    setIsLoading(false)
    doneLoading()
  }

  return (
    <div>
      {isLoading && <OverlayLoader />}

      <Panel header={schema.header} collapsible defaultExpanded bordered shaded>
        {schemaAttachments && (
          <div>
            <span>{schemaAttachments.header}</span>
            {isEdit && showCommandButton ? (
              <AttachFilesMakeContract
                schema={schemaAttachments}
                // register={register}
                // Controller={Controller}
                // control={control}
                // errors={errors}
                // setValue={setValue}
                // clearErrors={clearErrors}
                // onSubmit={handleSubmit(onUpload)}
                onSubmit={onUpload}
                onDelete={onDelete}
                onUpdate={onUpdate}
                onDownload={onDownload}
                onPreview={onPreview}
                isEditErr={isEditErr}
                isUploadErr={isUploadErr}
                isDeleteError={isDeleteError}
                loading={isLoading}
                onPrepareUploadFile={(isPrepareFile) => {
                  setIsPrepareFile(isPrepareFile)
                }}
              />
            ) : (
              <AttachFilesView
                schema={schemaAttachments.attachFiles}
                onDownload={onDownload}
                onPreview={onPreview}
              />
            )}

            {showCommandButton && (
              <Row>
                {!isEdit ? (
                  <EditButton
                    onClick={() => {
                      setIsEdit(!isEdit)
                      setIsEditErr(false)
                      setIsDeleteError(false)
                      setIsUploadErr(false)
                      //scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                    }}
                    disabled={isLoading}
                  >
                    {'เพิ่ม/แก้ไข' +
                      (schemaAttachments.buttonText ? schemaAttachments.buttonText : '')}
                  </EditButton>
                ) : (
                  <div>
                    <ViewButton
                      icon="backward"
                      onClick={() => {
                        setIsEdit(!isEdit)
                        setIsEditErr(false)
                        setIsDeleteError(false)
                        setIsUploadErr(false)
                        //scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                      }}
                      disabled={isLoading}
                    >
                      {'ดูรายการ' +
                        (schemaAttachments.buttonText ? schemaAttachments.buttonText : '')}
                    </ViewButton>
                  </div>
                )}
              </Row>
            )}
          </div>
        )}

        <br />

        {!isEditContract && isAIEvaliation && (
          <>
            <SaveButton
              block
              style={{ minWidth: 200, maxWidth: 300 }}
              icon="send"
              onClick={() => setEvalOpen(true)}
              children={'ประเมินคุณภาพข้อเสนอโครงการ'}
            />

            {evalOpen && (
              <AIEvaluationProcessWidget
                start={evalOpen}
                updateProcess={setEvalOpen}
                setEvaluationResultSchema={setEvaluationResultSchema}
              />
            )}

            {!evalOpen && evaluationResultSchema && (
              <>
                {evaluationResultSchema && (
                  <>
                    <AIEvaluationResultWidget
                      schema={evaluationResultSchema}
                      onCheck={handleCheckEvaluation}
                      onContinue={(val) => setIsContinue(val)}
                      isSend={true}
                    />
                  </>
                )}
              </>
            )}
            <hr />
          </>
        )}

        <ControlLabel>{requiredFiled(schema.note.validators, schema.note.label)}</ControlLabel>
        <ErrorMessage error={errors[schema.note.name]} />
        <br />
        <Input
          name={schema.note.name}
          inputRef={register(isValidators(schema.note.validators))}
          rows={4}
          placeholder={schema.note.label}
          componentClass="textarea"
        />
        <hr />
        {isError && (
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <Message showIcon type="error" description={isError} />
          </div>
        )}

        {isPrepareFile && (
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={`กรุณา "อัพโหลดแนบเอกสารเพิ่มเติม" ก่อนส่งขอแก้ไขสัญญา/ข้อตกลง`}
            />
          </div>
        )}

        {!isEditContract && isAIEvaliation && !evaluationResultSchema && (
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={`กรุณา "ประเมินคุณภาพข้อเสนอโครงการ" ก่อน${schema.buttonText}`}
            />
          </div>
        )}

        {!isEditContract &&
          evaluationResultSchema &&
          !isEmpty(evaluationResultSchema.statusMessage) && (
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <Message
                showIcon
                type="error"
                description={`กรุณา "รอผลประเมินคุณภาพข้อเสนอโครงการให้ครบ" ก่อน${schema.buttonText}`}
              />
            </div>
          )}

        {!isEditContract &&
          evaluationResultSchema &&
          isEmpty(evaluationResultSchema.statusMessage) &&
          (evaluationResultSchema?.score || 0) < (evaluationResultSchema?.minimumScore || 0) &&
          !isContinue && (
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <Message
                showIcon
                type="error"
                description={`คะแนนที่ได้ต่ำกว่าเกณฑ์ที่กำหนดกรุณา "ยืนยันการ${schema.buttonText}" ก่อน`}
              />
            </div>
          )}

        <SaveButton
          // block
          //style={{ minWidth: 200, maxWidth: 300 }}
          icon="send"
          onClick={handleSubmit(onSubmit)}
          disabled={
            isPrepareFile ||
            (!isEditContract &&
              isAIEvaliation &&
              (!evaluationResultSchema ||
                !isEmpty(evaluationResultSchema.statusMessage) ||
                ((evaluationResultSchema?.score || 0) <
                  (evaluationResultSchema?.minimumScore || 0) &&
                  !isContinue)))
          }
          children={schema.buttonText}
          // onClick={() => {
          // scrollToComponent(section1, { offset: 0, align: 'top', duration: 500 })
          // setHideHead(true)
          // setHideSubmit(false)
          // }}
        />
      </Panel>

      <ConfirmWidget
        title={`ยืนยันการ${schema.buttonText}`}
        show={showConfirm}
        detail={`กรุณายืนยันการ${schema.buttonText}`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => handleCallService()}
      />
    </div>
  )
}
